import React, { useEffect, useState } from "react";
import { HiChevronRight, HiOutlineSearch } from "react-icons/hi";
import { IoEyeOutline } from "react-icons/io5";
import { PiPlusBold } from "react-icons/pi";
import { Link } from "react-router-dom";

import { formatCreatedAt } from "../../utils/commonUtils";

import { useDispatch, useSelector } from "react-redux";
import { fetchFastFood } from "../../redux/slices/fastFoodSlice";
import ModalDeleteFastFood from "../../components/modals/modalStore/ModalDeleteFastFood";
import { ImSpinner2 } from "react-icons/im";
import ModalUpdateFood from "../../components/modals/modalStore/ModalUpdateFood";
import OpenFastFood from "../../components/modals/modalStore/OpenFastFood";
import CloseFastFood from "../../components/modals/modalStore/CloseFastFood";

const FastFood = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("all"); // "all", "open", "closed"
  const itemsPerPage = 10; // Number of items to display per page

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFastFood());
  }, [dispatch]);

  const fastFoods = useSelector((state) => state.fastFood?.fastFoods);

  // Filter fast foods based on search term and status filter
  const filteredFastFoods = fastFoods.filter((fast) => {
    // Apply search filter
    const searchMatch = search.trim() === "" 
      ? true 
      : fast?.name?.toLowerCase().includes(search.toLowerCase());

    // Apply status filter
    let statusMatch = true;
    if (statusFilter === "open") {
      statusMatch = fast.closed !== "1";
    } else if (statusFilter === "closed") {
      statusMatch = fast.closed === "1";
    }

    return searchMatch && statusMatch;
  });

  // Calculate the index of the first and last item to display on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentFastFoods = filteredFastFoods.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Calculate the total number of pages
  const totalPages = Math.ceil(filteredFastFoods.length / itemsPerPage);

  // Function to handle pagination
  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const status = useSelector((state) => state.fastFood?.status);
  const error = useSelector((state) => state.fastFood?.error);

  const countries = JSON.parse(localStorage.getItem("country"));
  const states = JSON.parse(localStorage.getItem("state"));
  const provinces = JSON.parse(localStorage.getItem("province"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  
  const isSuperAdmin = storedUser.role === "Super Admin";

  const getCountryNameById = (countryId) => {
    const parsedId = parseInt(countryId, 10);
    const country = countries.find((country) => country.id === parsedId);

    return country ? country.name : "Unknown";
  };

  const getStateNameById = (stateId) => {
    const parsedId = parseInt(stateId, 10);

    const state = states.find((state) => state.id === parsedId);

    return state ? state.name : "Unknown";
  };

  const getCityNameById = (cityId) => {
    const parsedId = parseInt(cityId, 10);
    const city = provinces.find((city) => city.id === parsedId);

    return city ? city.name : "Unknown";
  };

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="w-full h-auto text-2xl mb-2 text-[#333843] font-medium">
            Fast Food
          </h1>

          <div className="flex mb-4 justify-center items-center gap-2 mt-4">
            <Link to="/dashboard">
              <p className="text-[14px] text-[#1F7BF4] font-medium hover:underline">
                Dashboard
              </p>
            </Link>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#1F7BF4]  font-medium">Store</p>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#667085] font-medium">Fast Food</p>
          </div>
        </div>
      </div>
      
      <div className="flex justify-between mb-4">
        <div className="flex gap-4">
          <button className="relative w-72">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <HiOutlineSearch className=" text-gray-500 text-2xl" />
            </div>
            <input
              type="text"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
              placeholder="Search ..."
              onChange={(e) => setSearch(e.target.value)}
            />
          </button>
          
          {/* Status Filter Dropdown */}
          <div className="relative">
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-40 p-2.5 appearance-none"
            >
              <option value="all">All Fast Foods</option>
              <option value="open">Open Fast Foods</option>
              <option value="closed">Closed Fast Foods</option>
            </select>
            {/* <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div> */}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <Link to="/dashboard/shopping/add-fastfood">
            <button
              type="button"
              className="flex gap-[8px] bg-[#1F7BF4] text-white items-center py-2 px-4 text-[14px] hover:shadow-lg rounded-[8px] font-medium"
            >
              <PiPlusBold className=" text-lg font-extrabold" />
              Add Fast Food
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-white rounded-lg w-full p-4 h-auto shadow-md">
        <div className="relative overflow-x-auto rounded-t-lg">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="w-full text-sm text-gray-700 bg-gray-50 whitespace-nowrap">
              <tr>
                <th className="px-4 py-4 text-center">No.</th>
                <th className="px-12 py-4 text-center">Image</th>
                <th className="px-4 py-4 text-center">Name</th>
                <th className="px-4 py-4 text-center">Country</th>
                <th className="px-4 py-4 text-center">State</th>
                <th className="px-4 py-4 text-center">City</th>
                <th className="px-4 py-4 text-center">Status</th>
                <th className="px-4 py-4 text-center">Short Text</th>
                <th className="px-4 py-4 text-center">Location</th>
                <th className="px-4 py-4 text-center">Added</th>
                
                <th className="px-4 py-4 text-center">Status</th>
                <th className="px-4 py-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody className="w-full text-sm text-gray-700">
            {status === "failed" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      Error. {error}.{" "}
                      <span className="text-base font-semibold ">
                        {" "}
                        Try again later
                      </span>
                    </div>
                  </td>
                </tr>
              ) :status === "loading" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      <ImSpinner2 className="animate-spin h-8 w-8 text-gray-500" />
                    </div>
                  </td>
                </tr>
              ) : currentFastFoods.length === 0 ? (
                <tr>
                  <td colSpan="12" className="text-center text-gray-500 py-4">
                    No Data
                  </td>
                </tr>
              ) : (
                currentFastFoods?.map((food, index) => (
                  <tr key={index} className="bg-white border-b">
                    <td className="px-4 py-4">
                      <div className="flex justify-center items-center">
                        <p className=" text-base text-center font-semibold ">
                          {indexOfFirstItem + index + 1}
                        </p>
                      </div>
                    </td>
                    <td className="px-2 py-2">
                      <div className="flex items-center p-2 justify-center">
                        <img
                          src={food.image}
                          alt="food"
                          className="w-24 h-24 object-cover rounded-lg"
                        />
                      </div>
                    </td>
                    <td className="px-4 py-4 text-center">
                      <Link to={`/dashboard/shopping/fast-food/${food.id}?page=1`}>
                        <div className="ml-2">
                          <p className="text-blue-600 font-semibold whitespace-nowrap">
                            {food.name}
                          </p>
                        </div>
                      </Link>
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {getCountryNameById(food.country)}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {getStateNameById(food.state)}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {getCityNameById(food.province)}
                    </td>
                    <td className="px-4 py-4 text-center">{food.type}</td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {food.landmark}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {food.location}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {formatCreatedAt(food.created_at)}
                    </td>
                    <td className="px-4 py-4 text-center whitespace-nowrap">
                      {food.closed === "1" ? (
                        <OpenFastFood id={food.id} name={food.name} />
                      ) : (
                        <CloseFastFood id={food.id} name={food.name} />
                      )}
                    </td>

                    <td className="px-2 py-2">
                      <div className="flex gap-4 justify-center">
                        <Link to={`/dashboard/shopping/fast-food/${food.id}?page=1`}>
                          <IoEyeOutline className="w-4 h-4 text-[#667085]" />
                        </Link>
                        {isSuperAdmin  && 
                        <ModalUpdateFood
                          id={food.id}
                          image={food.image}
                          name={food.name}
                          note={food.note}
                          landmark={food.landmark}
                          location={food.location}
                          type={food.type}
                          country={food.country}
                          state={food.state}
                          province={food.province}
                        />
                        }
                        {isSuperAdmin  && 
                        <ModalDeleteFastFood
                          id={food.id}
                          image={food.image}
                          name={food.name}
                          landmark={food.landmark}
                          location={food.location}
                          type={food.type}
                          country={getStateNameById(food.country)}
                          state={getStateNameById(food.state)}
                          cities={getCityNameById(food.province)}
                        />}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between px-[24px] py-[15px] items-center">
          <p className="text-[14px] py-4 font-medium text-[#667085] tracking-[0.07px]">
            Showing {indexOfFirstItem + 1} - {indexOfLastItem} from{" "}
            {filteredFastFoods.length} fast foods
            {statusFilter !== "all" && ` (${statusFilter})`}
          </p>

          <div className="flex gap-[8px]">
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-md ${
                currentPage === 1
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Previous
            </button>

            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 rounded-md ${
                currentPage === totalPages
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FastFood;